export default __webpack_public_path__ + "static/B0261-ead1e185f95372ad915c7ba09c7d4d07.png";